import '@nsftx/seven-ng-ticket/dist/nsticket';
import './app';
import './betslipBlockOverlay';
import './betslipConfigProvider';
import './betslipController';
import './betslipService';
import './toggle/betslipToggle';

export default '7Terminal.Betslip';
